const prefix = 'fasr';
const iconName = 'align-right';
const width = 448;
const height = 512;
const aliases = [];
const unicode = 'f038';
const svgPathData = 'M424 40h24V88H424 184 160V40h24H424zm0 128h24v48H424 24 0V168H24 424zm24 128v48H424 184 160V296h24H424h24zM424 424h24v48H424 24 0V424H24 424z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
